<div class="page-container">
  <div class="page-header">
    <p class="page-title">Locations</p>
    <pdq-button
      [loading]="syncLoading"
      (onClick)="handleSync()"
      label="Sync locations"
      icon="sync"
      variant="light"></pdq-button>
  </div>
  @if (primaryLocation) {
    <div class="location-section">
      <p>Primary address</p>
      <location-card
        (onClick)="handleLocationClick($event)"
        clickable="true"
        [address]="primaryLocation"
        isDefault="true"></location-card>
    </div>
  }
  @if (postReturnAddress) {
    <div class="location-section">
      <p>Address for returns</p>
      <location-card
        (onClick)="handleLocationClick($event)"
        clickable="true"
        [address]="postReturnAddress"></location-card>
    </div>
  }
  @if (additionalLocations.length) {
    <div class="location-section">
      <p>Other locations</p>
      @for (address of additionalLocations; track address) {
        <location-card (onClick)="handleLocationClick($event)" clickable="true" [address]="address"></location-card>
      }
    </div>
  }
</div>
